import type { Contract } from '@essent/address';
import type { Tariffs } from '@essent/extension-offer';
import { createAction, props } from '@ngrx/store';

export const fetchCurrentContract = createAction(
  '[CurrentContract] Fetch current contract'
);

export const mapCurrentContract = createAction(
  '[CurrentContract] Map current contract from tariffs',
  props<{
    tariffs: Tariffs;
    contracts: Contract[];
  }>()
);

export const clearCurrentContract = createAction(
  '[CurrentContract] Clear current contract'
);
